import { ClientCartAction, SwarovskiOptikClientCart, UpdateMyCartEffectResponse } from "@swo/storefront";
import { Either } from "fp-ts/es6/Either";
import { fetchApiJson, getEndpointForFetch } from "../../../data-layer/fetch-api";
import * as E from "fp-ts/Either";
import * as NEA from "fp-ts/NonEmptyArray";

import { SwarovskiOptikErrorClientResponse } from "../types";
import { KNOWN_ERROR_UNKNOWN_ERROR } from "./KNOWN_ERROR_UNKNOWN_ERROR";

export const performCartAction =
  (token: string, localeCode: string, segmentKey: string, baseUrl?: URL) =>
  (actionBody: ClientCartAction): Promise<Either<SwarovskiOptikErrorClientResponse, SwarovskiOptikClientCart>> => {
    return fetchApiJson<UpdateMyCartEffectResponse>(
      getEndpointForFetch(`/storefront/shop/me/${localeCode}/${segmentKey}/cart`, baseUrl),
      {
        method: "POST",
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(actionBody),
      },
    )
      .then(res => {
        if (isSwarovskiOptikClientCart(res)) {
          return E.right(res);
        } else {
          return E.left(res);
        }
      })
      .catch(err => {
        console.error(err);
        if (Array.isArray(err?.errorResponse?.errors)) {
          return E.left({
            errors: err.errorResponse.errors,
          });
        }

        return E.left({
          errors: NEA.of(KNOWN_ERROR_UNKNOWN_ERROR),
        });
      });
  };

function isSwarovskiOptikClientCart(response: UpdateMyCartEffectResponse): response is SwarovskiOptikClientCart {
  return typeof (response as any)?.id === "string";
}
